// src/redux/slice/evl/evl0109m_slice.ts

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import type {
  IEvl0109mState,
  HrMapRow,
  EmployeeSearchKey,
} from "../../models/evl/evl0109m_model";

const currentYear = String(new Date().getFullYear());

const initialState: IEvl0109mState = {
  // 공통
  evlYear: currentYear,
  evlYearList: [],

  // HR 탭
  hrRows: [],
  hrLoading: false,

  // 검색(입력값)
  empSearchKey: "all",
  searchText: "",

  // 직급 공통코드(011)
  posClsMap: {},
};

export const evl0109m_Slice = createSlice({
  name: "evl0109m_Slice",
  initialState: initialState,
  reducers: {
    initState: () => initialState,

    // ===== 공통(탭 공유) =====
    setEvlYear: (state, action: PayloadAction<string>) => {
      state.evlYear = action.payload;
    },
    setEvlYearList: (state, action: PayloadAction<string[]>) => {
      state.evlYearList = action.payload ?? [];
    },

    // ===== HR 탭 데이터 =====
    setHrRows: (state, action: PayloadAction<HrMapRow[]>) => {
      state.hrRows = action.payload ?? [];
    },
    setHrLoading: (state, action: PayloadAction<boolean>) => {
      state.hrLoading = action.payload;
    },

    // ===== 검색 =====
    setEmpSearchKey: (state, action: PayloadAction<EmployeeSearchKey>) => {
      state.empSearchKey = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload ?? "";
    },
    resetSearch: (state) => {
      state.empSearchKey = "all";
      state.searchText = "";
    },

    // ===== 공통코드 맵 =====
    setPosClsMap: (state, action: PayloadAction<Record<string, string>>) => {
      state.posClsMap = action.payload ?? {};
    },
  },
});

export default evl0109m_Slice.reducer;
export const Evl0109mAction = evl0109m_Slice.actions;
export const Evl0109mReducer = evl0109m_Slice.reducer;
